import { render, staticRenderFns } from "./ChatOverlays.vue?vue&type=template&id=79b5e26b"
import script from "./ChatOverlays.vue?vue&type=script&lang=js"
export * from "./ChatOverlays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports